import React from "react";
import { useState, useEffect } from 'react';
import { fetchWithAuth } from "../../auth"
import { uf_timestamp } from '../../modules/utils.mjs'
import AddSensorGw from "../../dialogs/addSensorGW"

import '../../index.css';

const SensorsTableDB = ({
    serial
}) => {
    const [mysqlSensorsState, setMysqlSensorsState] = useState([]);

    async function fetchsensors() {
        await fetchWithAuth('/sensors/' + serial, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                setMysqlSensorsState(data)
            })
    }

    useEffect(() => {
        fetchsensors()
    }, [serial]);

    async function deleteSensor(event) {
        let _id = event.target.getAttribute('id_arg');
        await fetchWithAuth('/sensor', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: _id })
        })
        fetchsensors();
    }

    const [openAddSensorGw, setOpenAddSensorGw] = useState(false);
    const handleCloseAddSensorGw = () => {
        setOpenAddSensorGw(false)
        fetchsensors()
    };
    const handleOpenAddSensorGw = () => {
        setOpenAddSensorGw(true)
    };

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <AddSensorGw isOpen={ openAddSensorGw } onClose = { handleCloseAddSensorGw } gw = {serial}/>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px', backgroundColor: 'green', color: 'white', fontWeight: 'bold' }}>
                {isOpen ? 'Nascondi Sensors' : 'Mostra Sensors'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle_db" colSpan="2">Sensori</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
                        </tr>
                        <tr>
                            <th className="title">id sensore</th>
                            <th className="title">alive</th>
                            <th style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={handleOpenAddSensorGw}>Aggiungi</button>
                                <button onClick={fetchsensors}>Aggiorna</button>
                            </th>
                        </tr>
                        {mysqlSensorsState.map(mapSensor => (
                            <tr key={mapSensor.id}>
                                <td>{mapSensor.id}</td>
                                <td>{uf_timestamp(mapSensor.alive)}</td>
                                <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                    <button onClick={deleteSensor} id_arg={mapSensor.id}>elimina</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default SensorsTableDB;
